export default __webpack_public_path__ + "static/media/ABChanelCorpo-ExtraLight.89c587a8.ttf";